import { useRegisterSW } from 'virtual:pwa-register/react';
import './update-prompt.css';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      console.error('[SW] registration error', err);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <span className="update-prompt-msg">A new version is available.</span>
      <button className="update-prompt-btn" onClick={() => updateServiceWorker(true)}>
        Reload
      </button>
      <button
        className="update-prompt-dismiss"
        aria-label="Dismiss"
        onClick={() => setNeedRefresh(false)}
      >
        ×
      </button>
    </div>
  );
}
